import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import { initMemberSessionFromUrl } from "@/lib/memberSession";
import Landing from "@/pages/Landing";
import Diagnostic from "@/pages/Diagnostic";
import Report from "@/pages/Report";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
    useEffect(() => {
        initMemberSessionFromUrl();
    }, []);

    return (
        <div className="App" translate="no">
            <BrowserRouter>
                <ErrorBoundary>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/diagnostic" element={<Diagnostic />} />
                        <Route path="/report/:id" element={<Report />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                    </Routes>
                </ErrorBoundary>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
        </div>
    );
}

export default App;
